import { UtilService } from 'src/app/core/services/util/util.service';
import { Injectable, OnDestroy, inject } from '@angular/core';
import { NavigationEnd, Router, Event } from '@angular/router';
import { Observable, Subject, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { I18nService } from '../i18n/i18n.service';
import { StorageService } from '../storage/storage.service';
import { HistoryRoute } from './history-route.model';

@Injectable({
    providedIn: 'root',
})
export class HistoryRouteService implements OnDestroy {
    private _router = inject(Router);
    private _i18nService = inject(I18nService);
    private _storage = inject(StorageService);
    private _utils = inject(UtilService);

    readonly HISTORY_ROUTES: string = 'history routes';
    private _historyRoutes: HistoryRoute[] | undefined;

    public isPopBackNavigation: boolean = false;
    public isPopForwardNavigation: boolean = false;

    public navigationId: number = 0;
    private _subscriptions: Subscription[] = [];

    constructor() {
        const _router = this._router;

        // this._historyRoutesSub = new BehaviorSubject<HistoryRoute[]>(null)
        this._historyRoutesSub = new Subject<HistoryRoute[]>();
        this._subscriptions.push(
            _router.events.pipe(filter((e: Event | NavigationEnd): e is NavigationEnd => e instanceof NavigationEnd)).subscribe((ev: NavigationEnd) => {
                this._setHistoyRoutes(ev.id, ev.url);
            }),
        );
    }

    private _historyRoutesSub: Subject<HistoryRoute[]>;
    public gethistoryRoutes(): Observable<HistoryRoute[]> {
        return this._historyRoutesSub.asObservable();
    }
    public sethistoryRoutes(historyRoutes: HistoryRoute[]): void {
        this._historyRoutesSub.next(historyRoutes);
    }

    private _setHistoyRoutes(id: number, url: string): void {
        let historyRoutes: HistoryRoute[] = this._storage.load(this.HISTORY_ROUTES);
        if (!historyRoutes || !historyRoutes.length || this._getSecRange(historyRoutes[historyRoutes.length - 1].navigateAt) > 15) {
            historyRoutes = [];
        }
        historyRoutes.push(this._getHistoyRoute(id, url));
        this._historyRoutes = historyRoutes;
        this._storage.store(this.HISTORY_ROUTES, this._historyRoutes);
        this.sethistoryRoutes(this._historyRoutes);
    }
    private _getHistoyRoute(id: number, url: string): HistoryRoute {
        return {
            id,
            url,
            navigateAt: +Date.now(),
        };
    }

    private _getSecRange(prevNum: number = 0, currNum: number = +Date.now()): number {
        return this._getSecByMs(currNum) - this._getSecByMs(prevNum);
    }

    private _getSecByMs(ms: number = 0): number {
        return Math.floor(ms / 1000);
    }

    ngOnDestroy() {
        this._utils.unsubscribe(this._subscriptions);
        if (this._historyRoutesSub) this._historyRoutesSub.unsubscribe();
    }
}
